// Thin client over /api. Errors carry the server's message (trigger refusals are written to be read by people).
export class ApiError extends Error {
  constructor(message: string, public status: number, public detail?: { legal_moves?: Array<{ to_name: string }> } & Record<string, unknown>) { super(message); }
}

export async function api<T = any>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch('/api' + path, { method, headers: body ? { 'Content-Type': 'application/json' } : {}, body: body ? JSON.stringify(body) : undefined });
  let data: any = null;
  try { data = await res.json(); } catch { /* non-JSON */ }
  if (!res.ok) throw new ApiError(data?.error || `${res.status} ${res.statusText}`, res.status, data?.detail);
  return data as T;
}

export const enc = encodeURIComponent;
export const qs = (params: Record<string, string | number | undefined | null>) => {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') p.set(k, String(v));
  return p.toString();
};
